<button class="kebab-trigger" [cdkMenuTriggerFor]="menu" aria-label="Actions menu" (click)="$event.stopPropagation()">
    <div class="icon" [innerHTML]="kebabIcon"></div>
</button>

<ng-template #menu>
    <div class="actions-menu" cdkMenu>
        @for (action of visibleActions; track action.label) {
            <button class="menu-item" cdkMenuItem (click)="executeAction(action, $event)">
                {{ action.label }}
            </button>
        }
    </div>
</ng-template>
